// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Values_01.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
.section-news-shadow {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  background: #fcfcfc;
  box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);
}
.section-event-shadow {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);
}
.section-news-header {
  display: block;
  max-width: 1366px;
  padding: 60px 0px;
  margin-left: auto;
  margin-right: auto;
}
.news-header-text {
  width: 100%;
  display: flex;
}
.news-header-text .section-item-1 {
  width: 60%;
  padding: 0px 30px 0px 60px;
}
.news-header-text .section-item-2 {
  width: 30%;
  padding: 0px 60px 0px 30px;
}
.news-header-image {
  display: block;
  max-width: 1366px;
  padding: 0px 0px 60px 0px;
  margin-left: auto;
  margin-right: auto;
}
.news-header-image .news-header-image-group {
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}
.news-header-image .header-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
 /* <------ */
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  height: 480px;
  border-radius: 30px;
}
.section-news {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
  text-align: center;
  padding: 60px 0px 0px 0px;
}
.section-video {
  margin: 60px 0px 0px 0px;
  background: #ecebe6;
 
}
.video-player {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 100%;
  padding: 60px 0px;

}
.player-wrapper{
  /* position: relative; */
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
 
}
.react-player{
  display: inline;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  
  overflow: hidden;

  video{
    border-radius: 30px;
  }
}

.section-news-text {
  width: calc(100% - 120px);
  display: block;
  justify-content: center;
  align-items: center;
  padding: 0px 60px;
}
.section-news-text .section-tag {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.section-news-text .section-title {
  width: 100%;
  text-transform: uppercase;
}
.news-article {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 3fr));
  gap: 24px;
  overflow: auto;
  margin-left: auto;
  margin-right: auto;
}
.news-article .article-card {
  width: 100%;
  display: block;
  margin-top: 30px;
  text-align: left;
  position: relative;
}
.news-article .article-card .article-img-box {
  border-radius: 30px;
  height: 300px;
  background: #d3d1c5;
  display: flex;
  position: relative;
  overflow: hidden;

}
.news-article .article-card .article-img-box .article-img {
 display: inline-flex;
 margin-left: auto;
 margin-right: auto;

}
.news-article .article-card .article-button-group {
  display: block;
  position: absolute;
  right: 30px;
  bottom: 30px;
}
.news-article .article-card .article-button-group .article-button {
  border-radius: 20px;
  border: 1px solid #ecebe6;
  color: #fcfcfc;
  background: rgba(252, 252, 252, 0.2);
  backdrop-filter: blur(10px);
  padding: 10px 20px;
}
.news-article .article-card .team-member-info {
  padding: 16px 20px 0px 20px;
}
.member-name {
  padding: 20px 0px 0px 0px;
}
.section-news-content {
  text-align: center;
  padding: 60px 0px;
}
.tab-title {
  width: 100%;
  display: flex;
  justify-content: center;
}
.tab-title-group {
  display: flex;
  height: 61px;
  padding: 4px;
  align-items: center;
  text-align: center;
  width: fit-content;
  background-color: #eee;
  border-radius: 30px;
}
.tab-content {
  padding: 30px 60px 0px 60px;
}
.button-tab {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 30px;
  border: 0px;
}
.button-tab:hover {
  transform: scale(1.1);
  transition: transform 0.5s ease;
}
.button-tab.activeTab {
  border-radius: 30px;
  background: #cbbaa6;
}
.section-event {
  display: block;
  max-width: 1366px;
  padding: 60px 0px 0px 0px;
  margin-left: auto;
  margin-right: auto;
}
.event-header-text {
  width: 100%;
  display: flex;
}
.event-header-text .section-item-1 {
  width: 100%;
  padding: 0px 60px;
}
.event-header-image {
  display: block;
  max-width: 1366px;
  padding: 60px 0px 60px 0px;
  margin-left: auto;
  margin-right: auto;
}
.event-header-image .event-header-image-group {
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}
.event-header-image .header-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
 /* <------ */
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  height: 480px;
  border-radius: 30px;
}
.section-past-event {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
  text-align: center;
  padding: 0px;
}
.section-past-event .section-tag {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.section-past-event .section-title {
  width: 100%;
  text-transform: uppercase;
}
.section-past-event-content {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
  text-align: center;
  padding: 60px 60px;
}
.past-event {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
  overflow: auto;
  margin-left: auto;
  margin-right: auto;
}
.past-event .pastEvent-card {
  width: 100%;
  display: block;
  text-align: left;
  position: relative;
}
.past-event .pastEvent-card .pastEvent-img-box {
  border-radius: 30px;
  height: 300px;
  background: #d3d1c5;
  display: flex;
  position: relative;
  overflow: hidden;
}
.past-event .pastEvent-card .pastEvent-img-box .pastEvent-img {
  display: inline-flex;
    margin-left: auto;
    margin-right: auto;
}
.past-event .pastEvent-card .pastEvent-button-group {
  display: block;
  position: absolute;
  right: 30px;
  bottom: 30px;
}
.past-event .pastEvent-card .pastEvent-button-group .pastEvent-button {
  padding: 12px 24px;
  border-radius: 20px;
  border: 1px solid #ecebe6;
  color: #fcfcfc;
  background: rgba(252, 252, 252, 0.2);
  backdrop-filter: blur(10px);
}
.past-event .pastEvent-card .pastEvent-title-group {
  padding: 20px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}
.section-gallery {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
  text-align: center;
  padding: 60px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/news_web.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;AACA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;EACnB,kNAAkN;AACpN;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kNAAkN;AACpN;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mDAA2C;EAC3C,sBAAsB;CACvB,YAAY;EACX,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,mBAAmB;;AAErB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;;AAEnB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;;AAErB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;;EAEX,gBAAgB;;EAEhB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;AAElB;AACA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;;AAEnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mDAA2C;EAC3C,sBAAsB;CACvB,YAAY;EACX,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n.section-news-shadow {\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 30px;\n  background: #fcfcfc;\n  box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);\n}\n.section-event-shadow {\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 30px;\n  box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);\n}\n.section-news-header {\n  display: block;\n  max-width: 1366px;\n  padding: 60px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.news-header-text {\n  width: 100%;\n  display: flex;\n}\n.news-header-text .section-item-1 {\n  width: 60%;\n  padding: 0px 30px 0px 60px;\n}\n.news-header-text .section-item-2 {\n  width: 30%;\n  padding: 0px 60px 0px 30px;\n}\n.news-header-image {\n  display: block;\n  max-width: 1366px;\n  padding: 0px 0px 60px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.news-header-image .news-header-image-group {\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n.news-header-image .header-img {\n  background: url(\"../images/Values_01.webp\");\n  background-size: cover;\n /* <------ */\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: 100%;\n  height: 480px;\n  border-radius: 30px;\n}\n.section-news {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n  text-align: center;\n  padding: 60px 0px 0px 0px;\n}\n.section-video {\n  margin: 60px 0px 0px 0px;\n  background: #ecebe6;\n \n}\n.video-player {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  width: 100%;\n  padding: 60px 0px;\n\n}\n.player-wrapper{\n  /* position: relative; */\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 30px;\n \n}\n.react-player{\n  display: inline;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  \n  overflow: hidden;\n\n  video{\n    border-radius: 30px;\n  }\n}\n\n.section-news-text {\n  width: calc(100% - 120px);\n  display: block;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 60px;\n}\n.section-news-text .section-tag {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n.section-news-text .section-title {\n  width: 100%;\n  text-transform: uppercase;\n}\n.news-article {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 3fr));\n  gap: 24px;\n  overflow: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n.news-article .article-card {\n  width: 100%;\n  display: block;\n  margin-top: 30px;\n  text-align: left;\n  position: relative;\n}\n.news-article .article-card .article-img-box {\n  border-radius: 30px;\n  height: 300px;\n  background: #d3d1c5;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n\n}\n.news-article .article-card .article-img-box .article-img {\n display: inline-flex;\n margin-left: auto;\n margin-right: auto;\n\n}\n.news-article .article-card .article-button-group {\n  display: block;\n  position: absolute;\n  right: 30px;\n  bottom: 30px;\n}\n.news-article .article-card .article-button-group .article-button {\n  border-radius: 20px;\n  border: 1px solid #ecebe6;\n  color: #fcfcfc;\n  background: rgba(252, 252, 252, 0.2);\n  backdrop-filter: blur(10px);\n  padding: 10px 20px;\n}\n.news-article .article-card .team-member-info {\n  padding: 16px 20px 0px 20px;\n}\n.member-name {\n  padding: 20px 0px 0px 0px;\n}\n.section-news-content {\n  text-align: center;\n  padding: 60px 0px;\n}\n.tab-title {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.tab-title-group {\n  display: flex;\n  height: 61px;\n  padding: 4px;\n  align-items: center;\n  text-align: center;\n  width: fit-content;\n  background-color: #eee;\n  border-radius: 30px;\n}\n.tab-content {\n  padding: 30px 60px 0px 60px;\n}\n.button-tab {\n  display: flex;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 30px;\n  border: 0px;\n}\n.button-tab:hover {\n  transform: scale(1.1);\n  transition: transform 0.5s ease;\n}\n.button-tab.activeTab {\n  border-radius: 30px;\n  background: #cbbaa6;\n}\n.section-event {\n  display: block;\n  max-width: 1366px;\n  padding: 60px 0px 0px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.event-header-text {\n  width: 100%;\n  display: flex;\n}\n.event-header-text .section-item-1 {\n  width: 100%;\n  padding: 0px 60px;\n}\n.event-header-image {\n  display: block;\n  max-width: 1366px;\n  padding: 60px 0px 60px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.event-header-image .event-header-image-group {\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n.event-header-image .header-img {\n  background: url(\"../images/Values_01.webp\");\n  background-size: cover;\n /* <------ */\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: 100%;\n  height: 480px;\n  border-radius: 30px;\n}\n.section-past-event {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n  text-align: center;\n  padding: 0px;\n}\n.section-past-event .section-tag {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n.section-past-event .section-title {\n  width: 100%;\n  text-transform: uppercase;\n}\n.section-past-event-content {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n  text-align: center;\n  padding: 60px 60px;\n}\n.past-event {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 24px;\n  overflow: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n.past-event .pastEvent-card {\n  width: 100%;\n  display: block;\n  text-align: left;\n  position: relative;\n}\n.past-event .pastEvent-card .pastEvent-img-box {\n  border-radius: 30px;\n  height: 300px;\n  background: #d3d1c5;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n.past-event .pastEvent-card .pastEvent-img-box .pastEvent-img {\n  display: inline-flex;\n    margin-left: auto;\n    margin-right: auto;\n}\n.past-event .pastEvent-card .pastEvent-button-group {\n  display: block;\n  position: absolute;\n  right: 30px;\n  bottom: 30px;\n}\n.past-event .pastEvent-card .pastEvent-button-group .pastEvent-button {\n  padding: 12px 24px;\n  border-radius: 20px;\n  border: 1px solid #ecebe6;\n  color: #fcfcfc;\n  background: rgba(252, 252, 252, 0.2);\n  backdrop-filter: blur(10px);\n}\n.past-event .pastEvent-card .pastEvent-title-group {\n  padding: 20px 0px 0px 0px;\n  display: flex;\n  justify-content: space-between;\n}\n.section-gallery {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n  text-align: center;\n  padding: 60px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
